import { render, staticRenderFns } from "./commodityChange.vue?vue&type=template&id=6c73b343&scoped=true&"
import script from "./commodityChange.vue?vue&type=script&lang=js&"
export * from "./commodityChange.vue?vue&type=script&lang=js&"
import style0 from "./commodityChange.vue?vue&type=style&index=0&id=6c73b343&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c73b343",
  null
  
)

export default component.exports